import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { UserPICDataPayload, UserPICDataResponse } from "@/types/interface/user-pic";

async function createUserPic(payload: UserPICDataPayload) {
  return await http.post<APIResponse<UserPICDataResponse>>("user-pic/create", payload);
}

async function updateUserPic(idUserPic = '', payload: UserPICDataPayload) {
  return await http.patch<APIResponse<UserPICDataResponse>>(`user-pic/update?id=${idUserPic}`, payload);
}

async function getUserPic(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<UserPICDataResponse>>(`user-pic?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findUserPic(idUserPic = "") {
  return await http.get<APIResponse<UserPICDataResponse>>(`user-pic/detail?id=${idUserPic}`);
}

async function deleteUserPic(idUserPic = "") {
  return await http.delete<APIResponse<UserPICDataResponse>>(`user-pic/delete?id=${idUserPic}`);
}

export default {
  createUserPic,
  updateUserPic,
  getUserPic,
  findUserPic,
  deleteUserPic
};